import { AiAudioBadge } from "@/entities/compliance";
import { useCompliance } from "@/features/auth/model/AuthContext";

/**
 * 1011 算法备案 §5:音频播放器旁「AI生成」角标,受租户 `compliance.visibleLabel` 控制(缺省开)。
 *
 * ★放在 provider 层(@/contexts)而不是让各舱直接 `useCompliance()`:各舱已有大量单测把
 *   "@/contexts/AuthContext" 整个 mock 成只有 useAuth 的对象,直接调会在那些测试里 undefined 崩;
 *   这里直连真模块,无 AuthProvider 时 useCompliance 自带兜底。
 */
export function ComplianceAudioBadge({ className }: { className?: string }) {
  const { visibleLabel } = useCompliance();
  return visibleLabel ? <AiAudioBadge className={className} /> : null;
}
